import React from "react";

const IMAGE_FILENAMES = [
  "service_analytics.png",
  "service_insights.png",
  "service_productivity.png",
  "twodots_experiences.png",
  "twodots_logo.png"
];

const AssetsPage = () => {
  return (
    <div style={styles.pageShell}>
      <div style={styles.header}>
        <div>
          <p style={styles.subheading}>Assets · Gallery</p>
          <h1 style={styles.title}>Two Dots imagery</h1>
          <p style={styles.description}>
            A quick reference gallery for the images that represent the Two Dots brand and its
            services. Use [public]/images for the source files and download anything you need from
            here.
          </p>
        </div>
      </div>
      <div style={styles.galleryGrid}>
        {IMAGE_FILENAMES.map((filename) => (
          <article key={filename} style={styles.card}>
            <img
              src={`/images/${filename}`}
              alt={filename.replace(/_/g, " ").replace(".png", "")}
              style={styles.image}
            />
            <p style={styles.caption}>{filename}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

const styles = {
  pageShell: {
    minHeight: "100vh",
    padding: 32,
    color: "white",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  },
  header: {
    marginBottom: 32
  },
  subheading: {
    margin: 0,
    fontSize: 12,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.65)"
  },
  title: {
    margin: "8px 0",
    fontSize: 32
  },
  description: {
    maxWidth: 640,
    color: "rgba(255,255,255,0.7)",
    margin: 0
  },
  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: 24
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 16,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "center"
  },
  image: {
    width: "100%",
    borderRadius: 12,
    objectFit: "contain",
    maxHeight: 180
  },
  caption: {
    margin: 0,
    fontSize: 12,
    color: "rgba(255,255,255,0.6)"
  }
};

export default AssetsPage;
